export const PERMISSION_KEYS = {
  companies: {
    root: "companies",
    list: "companies.list",
    edit: "companies.edit",
  },
  monitorings: "monitorings",
  dashboard: {
    root: "dashboard",
    map: "dashboard.map",
    driversList: "dashboard.drivers_list",
    deviceInfo: "dashboard.device_info",
    trackingCreate: "dashboard.tracking_create",
    trackingList: "dashboard.tracking_list",
  },
  logs: {
    root: "logs",
    driverDailyLog: "logs.driver_daily_log",
    driverInfoBook: "logs.driver_info_book",
    driverCodriverReassign: "logs.driver_codriver_reassign",
    driverFirmwareUpdate: "logs.driver_firmware_update",
    driverAlarmSend: "logs.driver_alarm_send",
    mapLocation: "logs.map_location",
    driverInfoCopyButton: "logs.driver_info_copy_button",
    orgLogs: "logs.org_logs",
    openTransaction: "logs.open_transaction",
    driverWeeklyLog: "logs.driver_weekly_log",
    driverLogFreeze: "logs.driver_log_freeze",
    weeklyOrgLogs: "logs.weekly_org_logs",
    codriverReassign: "logs.codriver_reassign",
    orgLogTool: "logs.org_log_tool",
    createTool: "logs.create_tool",
    editTool: "logs.edit_tool",
    reassignTool: "logs.reassign_tool",
    transferTool: "logs.transfer_tool",
    deleteTool: "logs.delete_tool",
    bulkTool: "logs.bulk_tool",
    normalizeTool: "logs.normalize_tool",
  },
  violations: "violations",
  apiKeys: {
    root: "api_keys",
    list: "api_keys.list",
    generate: "api_keys.generate",
    edit: "api_keys.edit",
    delete: "api_keys.delete",
  },
  reports: {
    root: "reports",
    fmcsa: "reports.fmcsa",
    fmcsaList: "reports.fmcsa.list",
    fmcsaGenerate: "reports.fmcsa.generate",
    fmcsaDownload: "reports.fmcsa.download",
    ifta: "reports.ifta",
    iftaList: "reports.ifta.list",
    iftaGenerate: "reports.ifta.generate",
    iftaView: "reports.ifta.view",
    iftaDownloadDocs: "reports.ifta.download_docs",
    driversDaily: "reports.drivers_daily",
    driversDailyList: "reports.drivers_daily.list",
    driversDailyDownload: "reports.drivers_daily.download",
  },
  dvirs: {
    root: "dvirs",
    list: "dvirs.list",
    edit: "dvirs.edit",
    delete: "dvirs.delete",
  },
  drivers: {
    root: "drivers",
    listActive: "drivers.list_active",
    listTerminated: "drivers.list_terminated",
    create: "drivers.create",
    update: "drivers.update",
    terminate: "drivers.terminate",
    generate: "drivers.generate",
    activate: "drivers.activate",
  },
  vehicles: {
    root: "vehicles",
    listActive: "vehicles.list_active",
    listTerminated: "vehicles.list_terminated",
    create: "vehicles.create",
    update: "vehicles.update",
    terminate: "vehicles.terminate",
    activate: "vehicles.activate",
  },
  eldDevice: {
    list: "eld_device.list",
  },
  alarms: {
    root: "alarms",
    list: "alarms.list",
    actions: "alarms.actions",
  },
  resources: "resources",
  users: {
    root: "users",
    list: "users.list",
    add: "users.add",
    edit: "users.edit",
    assignAuditor: "users.assign_auditor",
    assignUser: "users.assign_user",
  },
  profiles: "profiles",
} as const;

